import { useEffect, useState } from "react";

import mergeImages from 'merge-images';
import { randomizerTractors } from "./randomizer-tractors";
import Attribute from "./Attribute";
import HomeLink from "./HomeLink";
import TopBanner from "./TopBanner";

export default function PreviewTractors() {
    const [isDisabled, setDisabled] = useState(false);
    const [imageSource, setImageSource] = useState();
    const [attributes, setAttributes] = useState<string[]>([]);
    const path = '/tractors/';

    const preview = async () => {
        console.log('indexing assets...');
        setDisabled(true);
        let assets = await fetch(path + 'assets.json')
            .then(r => r.json());

        let {images, attributes} = randomizerTractors(assets);
        setAttributes(attributes);

        console.log('making a random design...');
        mergeImages(images)
            .then((b64: any) => setImageSource(b64));

        setDisabled(false);
    }

    useEffect(() => {
        mergeImages([path + 'Backgrounds/BACKGROUND-Flag-Windy.png'])
            .then((b64: any) => setImageSource(b64));
    }, []);

    return (
        <div className="App-header">
            <div style={{width: '750px'}}>
                <TopBanner />
            </div>
            <div className="MainPanel">
                <div style={{paddingLeft: '50px', paddingRight: '50px', alignItems: 'center'}}>
                    <div style={{fontSize: '35px'}}>Preview Tractors and Tanks</div>
                    <div style={{fontSize: '15px'}}>Use this function to preview random asset combinations for your NFT.</div>
                    <div>
                        <button style={{width: '200px', height: '30px'}} onClick={preview} disabled={isDisabled}>PREVIEW</button>
                    </div>
                    <div style={{marginTop: '20px', display: 'flex', gap: '20px'}}>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '20px'}}>
                            <img alt='' style={{width: '500px', height: '500px', borderRadius: '8px'}} src={`${imageSource}`} />
                        </div>
                        <div style={{display: 'flex', flexDirection: 'column', gap: '10px'}}>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
                                { attributes.slice(0,2).map(attribute => <Attribute attribute={attribute}/>) }
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
                                { attributes.slice(2,4).map(attribute => <Attribute attribute={attribute}/>) }
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
                                { attributes.slice(4,6).map(attribute => <Attribute attribute={attribute}/>) }
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
                                { attributes.slice(6,8).map(attribute => <Attribute attribute={attribute}/>) }
                            </div>
                            <div style={{display: 'flex', flexDirection: 'row', gap: '10px'}}>
                                { attributes.slice(8,10).map(attribute => <Attribute attribute={attribute}/>) }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <HomeLink/>
        </div>
    );
}
